var addCss, answers, arrayConflicts, compareDates, containsObject, displayFiltered, divsLoaded, formtypes, ft_checked, ft_names, groupList, image_res, instanceBack, loadDataAutomatically, loadSession, pwrd, ques, reports, showcase, tableIdentifierNameMap, treeNode, us_checked, us_ft, userID, userName, users_id, users_name;

image_res = "/res/images/";

userName = window.userName;

pwrd = window.pwrd;

userID = window.userID;

users_id = [];

users_name = [];

us_checked = [];

us_ft = [];

formtypes = [];

ft_checked = [];

ft_names = [];

displayFiltered = false;

ques = {};

answers = {};

divsLoaded = false;

window.locations = [];

treeNode = null;

window.tableRows = [];

window.currentImageIndex = 0;

window.imageLength = 0;

showcase = void 0;

tableIdentifierNameMap = [];

loadDataAutomatically = false;

loadSession = false;

instanceBack = null;

arrayConflicts = [];

groupList = null;

reports = [];

addCss = function() {
  return $("#ui-datepicker-div").css({
    "z-index": "10"
  });
};


/*
Compares date 1 with date 2.
If date 1 is > date 2 returns true.
Otherwise returns false
 */

compareDates = function(date1, date2) {
  if (date1 > date2) {
    return true;
  }
  return false;
};


/*
  Portal initialization.
 */

$(document).ready(function() {
  if (userID !== void 0 && userID !== "") {
    return $("#leftPanel").createLeftPane();
  }
});

(function($) {
  var methods;
  methods = {
    init: function(options) {
      this.each(function() {
        var $t;
        return $t = $(this);
      });
      return this;
    }
  };
  return $.fn.createLeftPane = function(method) {
    if (methods[method]) {
      return methods[method].apply(this, Array.prototype.slice.call(arguments, 1));
    } else if (typeof method === "object" || !method) {
      return methods.init.apply(this, arguments);
    } else {
      return $.error("Method " + method + " does not exist!");
    }
  };
})(jQuery);

containsObject = function(obj, list) {
  var i;
  i = void 0;
  i = 0;
  while (i < list.length) {
    if (list[i] === obj) {
      return true;
    }
    i++;
  }
  return false;
};


/*
  Importing of data functions.
  Should be converted to backbone structure.
 */


/*
importData = importData || {}
importData .importMappings = false

importData.showImportModal = ->
  #clearTable("importTable")
  $("#importTable").empty()
  $('#importFileSelect').val(null)
  select = document.getElementById("importFormSelect")
  i = select.length
  while i >= 1
    select.remove i
    i--
  formCollection.each (model) ->
    if not model.get("isChild") and model.get("type") is "POI"
      select.add new Option(model.get("name"), model.get("id")), null

  if importData.importMappings isnt false
    importData.setImportMappings()
    $("#import-dialog").modal("show")
  else
    importData.loadFormMappings()


$(document).ready ->
  $('#importFileSelect').change(importData.handleCSVFileSelect)
  $('#importFormSelect').change(importData.importFormSelected)
  $('#geoCodeCheckBox').change(importData.geoCodeSelected)
  $('#importButtonSave').click(importData.uplodImportData)
  $('#import-button').click(importData.showImportModal)


importData.handleCSVFileSelect = (evt) ->
  files = evt.target.files # FileList object

   * Loop through the FileList and render image files as thumbnails.
  i = 0
  f = undefined
  fileData = null
  while f = files[i]
    if f.type.match("text/csv")? or f.type.match("text/plain")? or (f.type.match("application/vnd.ms-excel")? and f.name.endsWith(".csv"))
    else
      bootbox.alert "Only CSV formatted files allowed."
      $('#importFileSelect').val(null)
      return
    reader = new FileReader()
    reader.onload = ((theFile) ->
      (e) ->
        fileData = e.target.result
        data = Papa.parse(fileData)

        #rows = fileData.split(/\r/g)
        if data.data.length > 0
          rowOne = data.data[0]
          importData.createImportRows(rowOne)
          return
    )(f)
    reader.readAsText f
    i++
  return

importData.importFormSelected = ->
  formId = $("#importFormSelect").val()
  if formId is ""
    return
  file = document.getElementById("importFileSelect").files[0]
  if file
    reader = new FileReader()
    reader.readAsText(file, "UTF-8")
    reader.onload = ((theFile) ->
      (e) ->
        fileData = e.target.result
        data = Papa.parse(fileData)
        if data.data.length > 0
          rowOne = data.data[0]
          importData.createImportRows(rowOne)
          return
    )(file)
  return

importData.createImportRows = (row)->
  columns = []
  addressFields = {"address" : "", "street" : "", "city" : "", "zipcode" : "", "state" : ""}
  formId = $("#importFormSelect").val()
  if formId is ""
    return
  formModel = window.formCollection.get(formId)
  mapping = formModel.get("importMapping")
  $("#importTable").empty() #clearTable("importTable")
  $('#geoCodeCheckBox').attr('checked', false)
  $("#geoCodeCheckBox").attr("disabled", true)
  importQuestions = new Array()

  parseQuestion = (qn) ->
    unless qn.inVisible or not checkQType(qn.type)
      #unless qn.id is "Location1" or qn.id is "Location2" or qn.id is "Location3" or qn.id is "Location4"
      if qn.type is "IntQuestion" or qn.type is "StringQuestion" or qn.type is "FloatQuestion" or qn.type is "NameQuestion" or qn.type is "SelectMultipleQuestion" or qn.type is "SelectOneQuestion" or qn.type is "BooleanQuestion" or qn.type is "DateQuestion" or qn.type is "StatusQuestion"
        opt = "<option value='" + qn.id + "' data-type='" + qn.type + "'>" + qn.text + "</option>"
        importQuestions.push opt
      else if qn.type is "GPSQuestion" and formModel.get("hasCoordinates") is true
        opt = "<option value='Lon' data-type='GPSQuestion'>Longitude</option>"
        importQuestions.push opt
        opt = "<option value='Lat' data-type='GPSQuestion'>Latitude</option>"
        importQuestions.push opt

  unless formModel.get("type") is "TABLE"
    _.each formModel.get("questionPage"), (page) ->
      _.each page.question, parseQuestion

  if formModel.get("hasLocationHierarchy")
    importQuestions.push "<option value='Location1' data-type=''>" + locationLabels[0] + "</option>"
    importQuestions.push "<option value='Location2' data-type=''>" + locationLabels[1] + "</option>"
    importQuestions.push "<option value='Location3' data-type=''>" + locationLabels[2] + "</option>"
    importQuestions.push "<option value='Location4' data-type=''>" + locationLabels[3] + "</option>"


  #columnTest = row.split(';')
  #if columnTest.length > 1
   *  columns = columnTest
  #else
  columns = row
  columnIndexMap = {}
  window.previous = null
  i = 0
  while i < columns.length
    html = "<div class='row importRow'><div class='col-md-1'>" + (i + 1) + "</div><div class='col-md-5' id='importColumn-" + i + "'>" + columns[i] + "</div><div class='col-md-6'><select id='formQuestion-" + i + "' data-theme='bootstrap''><option></option>"
    columnIndexMap[columns[i]] = i
    j = 0
    while j < importQuestions.length
      html += importQuestions[j]
      j++
    html += "</select></div></div>"
    $('#importTable').append(html)

    $("#formQuestion-" + i).comboSelect()
    $("#formQuestion-" + i).focus ->
      window.previous = $(this).val()
    $("#formQuestion-" + i).change ->
      id = $(this).val()
      importTable = document.getElementById("importTable")
      rows = $('.importRow').length
      i = 0
      while i < rows
        qnId = $("#formQuestion-" + i).val()
        if qnId is id and $(this).attr("id") isnt "formQuestion-" + i and id isnt ""
          bootbox.alert "The selected question has already been selected."
          window.previous = null
          $($(this).parent("div").find("input[type='text']")[0]).val("")
          $($(this).parent("div").find("select")[0]).val("")
          $(this).val("")
          return
        else
          $($(this).parent("div").find("select")[0]).val($(this).val())
        i++
      formId = $("#importFormSelect").val()
      formModel = window.formCollection.get(formId)

      if addressFields[id] isnt undefined and formModel.get("includeAddress") is true and (account_type isnt "Light" or window.db is "airliquide")
        $("#geoCodeCheckBox").removeAttr("disabled")
        window.previous = null
    i++

   * Process mapings which have been saved to database
  if mapping? and mapping isnt "null"
    table = document.getElementById("importTable")
    rowCount = $('.importRow').length
    map = JSON.parse mapping
    i = 0
    while i < map.length
      obj = map[i]
      if obj.Lat? and obj.Lon?
        index = columnIndexMap[obj.Lat.columnName]
        if index?
          $("#geoCodeCheckBox").removeAttr("disabled") if addressFields[obj.questionId] isnt undefined and formModel.get("includeAddress") is true
          $("#formQuestion-" + index).val(obj.Lat.questionId)
          $($("#formQuestion-" + index).parent("div").find("input[type='text']")[0]).val($("#formQuestion-" + index + " option:selected").html())
        index = columnIndexMap[obj.Lon.columnName]
        if index?
          $("#geoCodeCheckBox").removeAttr("disabled") if addressFields[obj.questionId] isnt undefined and formModel.get("includeAddress") is true
          $("#formQuestion-" + index).val(obj.Lon.questionId)
          $($("#formQuestion-" + index).parent("div").find("input[type='text']")[0]).val($("#formQuestion-" + index + " option:selected").html())
      else
        index = columnIndexMap[obj.columnName]
        if index?
          $("#geoCodeCheckBox").removeAttr("disabled") if addressFields[obj.questionId] isnt undefined and formModel.get("includeAddress") is true
          $("#formQuestion-" + index).val(obj.questionId)
          $($("#formQuestion-" + index).parent("div").find("input[type='text']")[0]).val($("#formQuestion-" + index + " option:selected").html())

      i++
  return

clearTable = (tableId) ->
  table = document.getElementById(tableId)
  rowCount = table.rows.length
  i = rowCount - 1
  while i >= 1
    table.deleteRow(i)
    i--
  return

importData.uplodImportData = ->
  if $("#importFormSelect").val() is "" or not $("#importFormSelect").val()?
    bootbox.alert title: "Error", message : "#{messages.noImportFormError}"
    return

  unless document.getElementById("importFileSelect").files[0]?
    bootbox.alert title: "Error", message : "#{messages.noImportFileError}"
    return

  data = new FormData()
  data.append "file", file = document.getElementById("importFileSelect").files[0]
  mappings = []

  formId = $("#importFormSelect").val()
  formModel = window.formCollection.get(formId)
  formIdentifier = formModel.get("ref")
  data.append "customTable", formModel.get("answerTable")

  table = document.getElementById("importTable")
  rowCount = $('.importRow').length
  i = 0
  coord = {}
  while i < rowCount
    mapping = {}
    mapping.questionId = $("#formQuestion-" + i).val()
    mapping.index = i
    mapping.columnName = $("#importColumn-" + i).html()
    opt = $("#formQuestion-" + i).find(":selected")
    mapping.questionType = $(opt).data("type")
    if mapping.questionType is "GPSQuestion"
      coord[mapping.questionId] = mapping
    else
      mappings.push mapping
    i++
  mappings.push coord if coord.Lat? and coord.Lon
  data.append "mappings", JSON.stringify(mappings)
  geoCode = $("#geoCodeCheckBox").is(':checked')
  $("#import-dialog").modal("hide")
  showProgress()
  $("#progressMessage").html("Uploading data...")
  $.ajax
    type: "POST"
    data: data
    cache: false
    processData: false
    contentType: false
    headers:
      userid: userName
      key: pwrd
    url: "#{baseUrl}app/import/#{formId}/#{groupID}/#{userID}/#{geoCode}/#{formIdentifier}"
    success: (result, textStatus, jqXHR) ->
      closeProgress()
      if result.status is "OK"
        $("#count_#{formId}").html("(" + result.row_id + ")")
        #updateCurrentSelection()
        $("#poi#{formModel.id}").trigger("change")
        bootbox.alert(result.message)
      else
        bootbox.alert result.message
    error: (error) ->
      closeProgress()
      bootbox.alert "Error importing data, try again."
  return

importData.loadFormMappings = ->
  showProgress()
  $("#progressMessage").html("Loading mappings...")
  ids = []
  formCollection.each (model) ->
    if not model.get("isChild") and model.get("type") is "POI"
      ids.push model.get("id")
  if ids.length <= 0
    bootbox.alert "Forms have not been loaded yet, please wait for forms to be loaded"
    closeProgress()
    return
  data = {}
  data.poiIdentifier = ids
  $.ajax
    type: "POST"
    data: JSON.stringify(data)
    headers:
      "Content-Type": "application/json"
      userid: userName
      key: pwrd
    url: "#{baseUrl}app/import/mapping"
    success: (result, textStatus, jqXHR) ->
      for key of result
        formModel = window.formCollection.get(key)
        formModel.attributes.importMapping = result[key]
      importData.importMappings = true
      importData.setImportMappings()
      closeProgress()
      $("#import-dialog").modal("show")
    error: (error) ->
      closeProgress()
      $("#import-dialog").modal("show")
      bootbox.alert "Error getting mappings "

  return

importData.setImportMappings = ->
  select = document.getElementById("importFormSelect").options
  i = 0
  while i < select.length
    opt = select.item(i)
    id = $(opt).attr("value")
    formModel = window.formCollection.get(id)
    $(opt).data("mapping", importData.importMappings[id])
    i++
  return


importData.geoCodeSelected = ->
  if $("#geoCodeCheckBox").is(':checked')
    table = document.getElementById("importTable")
    rowCount = $('.importRow').length
    i = 0
    addressFields = {"address" : "", "street" : "", "city" : "", "zipcode" : "", "state" : ""}
    address = false
    while i < rowCount
      address = true if addressFields[$("#formQuestion-" + i).val()] isnt undefined
      i++
    if !address
      bootbox.alert "There is no address fields mapped, geo coding cannot be done"
      $('#geoCodeCheckBox').attr('checked', false)
      $("#geoCodeCheckBox").attr("disabled", true)
 */

//# sourceMappingURL=maps/load.js.map
